import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';
import { boxShadow } from '../../theme/colorPalette';

const { palette, spacing } = lightTheme;

const styles: Record<string, SxProps> = {
  cardMainBox: {
    borderRadius: '0.5rem',
    padding: spacing(0.5),
    backgroundColor: palette.grey['50'],
    boxShadow: boxShadow[300],
    width: '100%'
  },

  cardActionArea: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    background: 'none',
    border: 'none',
    padding: '0'
  },

  clickableCardActionArea: {
    cursor: 'pointer'
  },

  expandIconBox: {
    marginLeft: 'auto',
    display: 'flex',
    color: palette.grey.main,
    '& svg': {
      fontSize: '1.75rem'
    }
  },

  detailBox: {
    padding: '0',
    marginTop: spacing(0.5)
  },

  nameTitle: {
    color: palette.grey.main,
    textAlign: 'left',
    display: 'flex',
    marginY: spacing(0.5)
  },

  subtitle: {
    color: palette.primary.main,
    textAlign: 'left'
  },

  descriptionText: {
    '.markdown': {
      color: palette.grey.main,
      minHeight: {
        xs: '18rem',
        md: '12rem',
        mm: '15rem',
        lg: '12rem',
        xl: '10.3rem'
      },
      '& .MuiTypography-body1:last-child': {
        marginBottom: '0'
      }
    }
  },

  contactBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '0.25rem'
  },

  contactBoxText: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(0.5)
  },

  contactText: {
    color: palette.primary.main,

    a: {
      textDecoration: 'underline',
      color: palette.primary.main
    }
  },

  contactTextWechat: {
    color: palette.primary.main,

    a: {
      textDecoration: 'none',
      color: palette.primary.main
    }
  },

  qrText: {
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: palette.grey.main,
    mb: '1rem'
  },

  mainImgBox: {
    minHeight: '15rem'
  }
};

export default styles;
